import React, { useEffect, useState } from 'react'
import Layout from '../../../components/common/pageLayout'
import { toast } from 'react-toastify'
import ListModules from '../../../components/Administration/module/list'
import constant from '../../../constant'
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min'
import { v3_mapped_modules, v3_module_assign, v3_modules } from '../../../actions/v3/module'

const List = (props) => {

    const location = useLocation();
    const { designationId } = location.state || {};
    const [data, setData] = useState(null)
    const [currentPage, setCurrentPage] = useState(1)
    const [limit, setLimit] = useState(20)
    const [previouslyMappedModules, setPreviouslyMappedModules] = useState([])

    useEffect(() => {
        v3_modules(currentPage, limit).then((res) => {
            if (res.status) {
                setData(res.result);
            }
            else {
                toast.error(res.error)
            }
        })
    }, [currentPage, limit])


    useEffect(() => {
        v3_mapped_modules(designationId).then((res) => {
            if (res.result) {
                setPreviouslyMappedModules(res.result)
            }
        })
    }, [])


    const handleSubmit = (permissions) => {
        v3_module_assign({ permissions: permissions, designationId }).then((res) => {
            if (res.result) {
                toast.success(res.result.message)
            }
            else {
                toast.error(res.error || res.error.message)

            }
        })
    }
    return (
        <Layout
            title={'Module List'}
        >
            {data && <ListModules
                previouslyMappedModules={previouslyMappedModules}
                limit={limit}
                data={data}
                handleSubmit={handleSubmit}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
            />}
        </Layout>
    )
}

export default List